import { render, staticRenderFns } from "./ProductTypeSupplierComponent.vue?vue&type=template&id=22f4f85b"
import script from "./ProductTypeSupplierComponent.vue?vue&type=script&lang=js"
export * from "./ProductTypeSupplierComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports